/* eslint-disable react/forbid-prop-types */
import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

export const TabPanel = memo(({
  children, value, index, keepMounted = true, ...other
}) => {
  const hidden = value !== index;

  return (
    <Box
      className="dn-tab-panel"
      role="tabpanel"
      id={`dn-tabpanel-${index}`}
      aria-labelledby={`dn-tab-${index}`}
      {...other}
      display={hidden ? 'none !important' : undefined}
    >
      {
        (!hidden || keepMounted) && (
          <Box>{children}</Box>
        )
      }
    </Box>
  );
});

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  keepMounted: PropTypes.bool,
};
